import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import React from 'react';

export const AppNotificationsProvider: React.FC = ({ children }) => {
  return (
    <>
      <ToastContainer
        position={'bottom-right'}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {children}
    </>
  );
};
